import React, { Component } from 'react'
import { connect } from "react-redux"
import trans from "trans"
import _sortBy from "lodash/sortBy";
import _forEach from "lodash/forEach";

import {
    css,
    Spinner,
    InputGroup,
} from "@bdfx/mergado-ui-kit"

import { updateInputValue as change } from "app/reducers/form"

import { Project, Query, Template } from "app/types/model-types"
import { createToast } from "actions";
import { ReduxList } from "app/types/app-types";
import CreatePredefinedQueries from 'products/components/create-predefined-queries'
import { getHelperContentByActiveView, setHelperText } from 'template-edit/components/helper'
import { selectFormValues } from 'app/reducers/form';
import { ACTIVE_VIEW_EDIT_QUERIES } from 'template-edit/containers/Editor';

export const ALL_PRODUCTS_QUERY = "♥ALLPRODUCTS♥"

export interface Props {
    queries: ReduxList<Query>
    templateForm: Template
    checkIsValid: boolean
    change: typeof change
    createToast: typeof createToast
}

class QueriesForm extends Component<Props> {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.checkIfQueryExists()
    }

    checkIfQueryExists = () => {
        const { queries, templateForm } = this.props

        if (queries.isLoaded && queries.data.length > 0 && templateForm.queries && Array.isArray(templateForm.queries) && templateForm.queries.length > 0) {
            const existingQueryIds = queries.data.map(q => String(q.id))
            const updatedQueries = templateForm.queries.filter(queryId => existingQueryIds.includes(String(queryId)))
            if (!updatedQueries.length) {
                console.debug('removed non existing queries from ', templateForm.queries, existingQueryIds, updatedQueries)
            }
            this.props.change('templateForm', 'queries', updatedQueries)
        }
    }


    render() {
        const { queries, templateForm } = this.props


        if (!queries.isLoaded || !queries.data) {
            return <Spinner type={"bubbles"} />
        }

        const items = _sortBy(queries.data, [(query: Query) => {
            return !query.name
        }]).map((o: Query) => {
            const queryName = o.name === ALL_PRODUCTS_QUERY ? trans("all_products") : o.name
            return {
                label: queryName,
                text: <span>
                    <span title={`${o.id}`}>{queryName}</span>
                    <span style={{ fontSize: '12px', color: '#707070', paddingLeft: '6px' }}> {o.product_count}</span>
                </span>,
                value: `${o.id}`,
            }
        })

        return (
            <StyledDiv>
                <InputGroup
                    search={true}
                    name="templateForm.queries"
                    value={templateForm.queries}
                    items={items}
                    placeholder={trans("filter")}
                    onChange={(value) => {
                        setHelperText(getHelperContentByActiveView(ACTIVE_VIEW_EDIT_QUERIES, { templateForm: { queries: value }, queries }))
                    }}
                    orientation='vertical'
                />


                <CreatePredefinedQueries printExisting={true} />
            </StyledDiv>
        )
    }
}

const StyledDiv = css('div')({
    ' .muk-form-group label.muk-form-label': {
        padding: '4px 10px',
    }
})

function mapStateToProps(state) {
    return {
        queries: state.queries,
        templateForm: selectFormValues(state, 'templateForm'),
    }
}

export default connect(mapStateToProps, {
    change,
    createToast,
})(QueriesForm)